import { StyleSheet } from 'react-native';

export const getActiveChallengesSectionStyles = () =>
  StyleSheet.create({
    activeChallengesContainer: {
      paddingBottom: 16,
      backgroundColor: 'transparent',
    },
    activeChallengesCardsContainer: {
      paddingHorizontal: 16,
    },
  });
